import { createContext, useContext } from "react";

/**
 * How `ControlBarItem` lays out its label relative to its control:
 *   - "beside" (default): label sits inline to the left of the control.
 *   - "above": label sits as a small caption stacked above the control.
 *
 * This is a per-bar setting, not per-control — a single provider at the bar
 * level flips every `ControlBarItem` inside it, so a filter row can't end up
 * a mishmash of beside/above labels.
 */
export type ControlBarLabelPosition = "beside" | "above";

const ControlBarLabelContext = createContext<ControlBarLabelPosition>("beside");

export const ControlBarLabelProvider = ControlBarLabelContext.Provider;
export const useControlBarLabelPosition = () =>
  useContext(ControlBarLabelContext);
